module.exports = __webpack_public_path__ + "static/media/kaduha_mugano_mushubi_road7.17a25cb5.jpg";